import React, { useContext } from "react";
import { Space, PageHeader, Table, Empty, Alert, Row, Col } from "antd";

import LanguageSwitcher from "../LanguageSwitcher";
import { GlobalContext } from "../GlobalContext";

import { columns } from "./columns";

const ScoresAi = () => {
    const { language, userData } = useContext(GlobalContext);

    return (
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <PageHeader
                className="site-page-header"
                title="Scores — AI Battle Mode"
            />
            <div style={{ padding: "0 24px" }}>
                <Row style={{ marginBottom: `24px` }}>
                    <Col span={12} align="right" push={12}>
                        <LanguageSwitcher />
                    </Col>
                </Row>

                {userData && userData.record_ai_battle?.length ? (
                    <Table
                        columns={columns(language)}
                        dataSource={userData.record_ai_battle}
                        pagination={true}
                        size="small"
                        sticky={{
                            offsetHeader: 0,
                        }}
                    />
                ) : (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No score data. Go play some songs!"
                    />
                )}
            </div>
        </Space>
    );
};

export default ScoresAi;
